import omit from 'lodash/fp/omit';
import set from 'lodash/fp/set';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { stringify } from 'query-string';
import { actionRequestNextPage } from 'actions';
import { CONTENT_ARCHIVE } from 'config/types/prop';
import { ARCHIVE } from 'config/types/content/component';
import { options } from 'config/reactRedux';
import { getLoading } from 'selectors';
import getMatch from 'selectors/getMatch';
import { getEdition } from 'selectors/getEdition';
import getModules from 'selectors/getModules';
import { createGetComponentByContentType } from 'selectors/createGetComponent';
import getContentArchive from 'selectors/getContentArchive';
import withLoader from '../hoc/withLoader';

const ContentArchive = (props) => {
  const Archive = props.component;
  return (
    <div>
      <Archive {...omit(['component'], props)} />
    </div>
  );
};

ContentArchive.propTypes = {
  ...CONTENT_ARCHIVE,
  modules: PropTypes.object,
  component: PropTypes.elementType.isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  pageMeta: PropTypes.shape({
    controls: PropTypes.objectOf(
      PropTypes.shape({
        selected: PropTypes.string,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
          }).isRequired,
        ),
      }),
    ).isRequired,
  }).isRequired,
};

ContentArchive.defaultProps = {
  modules: {},
};

const mapStateToProps = (state) => {
  const contentArchive = getContentArchive(state);
  const loading = getLoading(state);
  const getComponent = createGetComponentByContentType(
    contentArchive.contentType,
    ARCHIVE,
  );
  const component = getComponent(state);
  const match = getMatch(state);

  return {
    ...contentArchive,
    component,
    loading: loading.content || !component,
    loadingMore: loading.more,
    modules: getModules(state),
    match,
    currentEdition: getEdition(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoadMore: (e) => {
    e.preventDefault();
    dispatch(actionRequestNextPage());
  },
  createOnChangeFilter: (url, query) => (e) => {
    e.preventDefault();

    const { name, value } = e.target;
    const newQuery = stringify(
      set(name, value || undefined, query),
      { arrayFormat: 'bracket' },
    );

    dispatch(push(`${url}?${newQuery}`));
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { match: { url, query } } = stateProps;
  const { createOnChangeFilter } = dispatchProps;
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onChangeFilter: createOnChangeFilter(url, query),
  };
};

const withRedux = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
  options,
);

export default withRedux(withLoader(ContentArchive));
